export default {"src":"/_next/static/media/white-kitchen.c58c5b36.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};